import ViewingMode from 'shared/components/viewing-mode-controller/types/viewing-mode';
import OrganisationTreeNode from 'shared/features/organisation/models/organisation-tree-node';

export default class AlternativeDiversionValidator {
  static checkSingleAlternativeDiversionRule(
    viewingMode: ViewingMode,
    parentNode: OrganisationTreeNode | undefined,
    selectedNode: OrganisationTreeNode | undefined,
    upstreamParentBranch: OrganisationTreeNode[],
  ): boolean {
    if (
      !parentNode?.id ||
      (!this.hasAlternativeDivertionRuleInParents(parentNode.id, upstreamParentBranch) &&
        !this.hasAlternativeDivertionRuleInChildren(viewingMode === 'editing' ? selectedNode?.childOrganisationUnits : undefined))
    ) {
      return true;
    }

    return false;
  }

  private static hasAlternativeDivertionRuleInChildren(childOrganisationUnits: OrganisationTreeNode[] | undefined): boolean {
    if (!childOrganisationUnits) {
      return false;
    }

    let anyChildHasAlternativeDivertionRule = false;
    for (const child of childOrganisationUnits) {
      if (child.hasAlternativeDiversionOrganisationUnits) {
        anyChildHasAlternativeDivertionRule = true;
        break;
      }

      if (this.hasAlternativeDivertionRuleInChildren(child.childOrganisationUnits)) {
        anyChildHasAlternativeDivertionRule = true;
        break;
      }
    }
    return anyChildHasAlternativeDivertionRule;
  }

  private static hasAlternativeDivertionRuleInParents(parentId: string | undefined, upstreamParentBranch: OrganisationTreeNode[]): boolean {
    if (!parentId) {
      return false;
    }

    const parent = upstreamParentBranch.find((node) => node.id === parentId);
    if (parent?.hasAlternativeDiversionOrganisationUnits) {
      return true;
    } else if (parent?.isLocation) {
      return false;
    }

    return this.hasAlternativeDivertionRuleInParents(parent?.parentId, upstreamParentBranch);
  }

  static hasLocationInParents(parentId: string | undefined, upstreamParentBranch: OrganisationTreeNode[]): boolean {
    if (!parentId) {
      return false;
    }
    const parent = upstreamParentBranch.find((node) => node.id === parentId);
    if (parent?.isLocation) {
      return true;
    }

    return this.hasLocationInParents(parent?.parentId, upstreamParentBranch);
  }
}
